<template>
    <div class="sw-survey-container">
        <div class="sw-width-full" v-if="!success">
            <form ref="form" class="sw-flex">
                <component :component="form"
                           @submit="submit"
                           @updateContact="fillForm($event, 'contactData')"
                           @updateSurvey="fillForm($event, 'surveyData')"
                           :is="'form-slide'"
                           :contact-form="contactForm"
                           :survey-form="form">
                </component>
            </form>
        </div>
        <template v-else>
            <div id="sw-anchor-2"></div>
            <div class="sw-mx-auto sw-thanks-message">
                {{ form.thanks_message }}
            </div>
        </template>
    </div>
</template>

<script>
import FormCheckbox from '@/Pages/Forms/Partials/Checkbox.vue'
import Form from '@/Pages/Forms/Partials/Form.vue'
import FormInput from '@/Pages/Forms/Partials/Input.vue'
import FormDate from '@/Pages/Forms/Partials/Date.vue'
import FormTextarea from '@/Pages/Forms/Partials/Textarea.vue'
import FormSelect from '@/Pages/Forms/Partials/Select.vue'
import FormColumn from '@/Pages/Forms/Partials/Column.vue'
import FormButton from '@/Pages/Forms/Partials/Button.vue'
import axios from "axios";
import download from "downloadjs";
import FormScalaQuestion from "@/Pages/Forms/Partials/ScalaQuestion.vue";
import FormSlide from "@/Pages/Forms/Partials/Slide.vue";

export default {
    name: "PublicSurvey",
    components: {
        FormCheckbox,
        FormColumn,
        FormInput,
        FormDate,
        Form,
        FormTextarea,
        FormSelect,
        FormButton,
        FormScalaQuestion,
        FormSlide
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        contactForm: {
            type: Object
        }
    },
    computed: {
        origin() {
            if (typeof this.form.origin !== 'undefined') {
                return this.form.origin;
            }
            return 'https://tracker.schubwerk.de';
        }
    },
    data() {
        return {
            contactData: {},
            surveyData: {},
            success: false,
            loading: false,
        }
    },
    methods: {
        fillForm(ev, dataVarName) {
            if (!Object.keys(this[dataVarName]).includes(ev.id)) {
                this.$set(this[dataVarName], ev.id, ev.value);
                this.$forceUpdate();
            } else {
                this[dataVarName][ev.id] = ev.value;
                this.$forceUpdate();
            }
        },
        async submit() {
            this.loading = true;
            await axios.post(this.origin+'/api/form/'+this.form.id+'/submit/survey', {
                surveyData: this.surveyData,
                trackContact: this.form.settings.track_contact,
                contactData: this.contactData
            }, {
                method : "POST",
                mode: 'cors',
                responseType: "blob",
                onSuccess: () => {
                    this.loading = false;
                    this.success = true
                },
                onError: () => this.loading = false
            }).then((response) => {
                const content = response.headers["content-type"];
                let fileName='LKSG_Quick-Check'
                if (this.contactData.firmName) {
                    fileName = fileName + '_' + this.contactData.firmName;
                }
                let date=new Date()
                fileName = fileName + '_' + date.getDate() + '.' + (date.getMonth()+1) + '.' + date.getFullYear()+'.pdf';
                download(response.data, fileName, content);
                this.loading = false;
                this.success = true;
                alert('Ihre Auswertung wird automatisch als PDF generiert und heruntergeladen, sobald Sie auf "Ok" drücken. Die PDF ist anschließend im Download-Bereich ihres Browsers verfügbar.');
            });
        }
    }
}
</script>

<style lang="sass">

.sw-survey-container
    display: flex
    width: 100%
    height: 100%

.sw-width-full
    width: 100%

.sw-mx-auto
    margin: auto auto

</style>
